enum SelectionType {
  REQUEST = "REQUEST",
  OPT_IN = "OPT_IN",
  REQUEST_AND_OPT_IN = "REQUEST_AND_OPT_IN"
}
export default SelectionType;
